module.exports = __webpack_public_path__ + "static/media/salesforce.08917b98.png";